var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 73,
    viewBox: "0 0 192 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77875 1C6.67418 1 5.77875 1.89543 5.77875 3V58C5.77875 59.1046 6.67419 60 7.77876 60H19.9102C14.4066 67.0398 5.62596 70.8386 1 72C16.5353 71.1875 27.4685 65.4387 34.0222 60H189C190.105 60 191 59.1046 191 58V3C191 1.89543 190.105 1 189 1H7.77875Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9102 60L20.3041 60.308L20.9357 59.5H19.9102V60ZM1 72L0.878252 71.515L1.02612 72.4993L1 72ZM34.0222 60V59.5H33.8417L33.7028 59.6152L34.0222 60ZM6.27875 3C6.27875 2.17157 6.95032 1.5 7.77875 1.5V0.5C6.39804 0.5 5.27875 1.61929 5.27875 3H6.27875ZM6.27875 58V3H5.27875V58H6.27875ZM7.77876 59.5C6.95033 59.5 6.27875 58.8284 6.27875 58H5.27875C5.27875 59.3807 6.39805 60.5 7.77876 60.5V59.5ZM19.9102 59.5H7.77876V60.5H19.9102V59.5ZM19.5163 59.692C14.1042 66.6146 5.43941 70.37 0.878252 71.515L1.12175 72.485C5.81251 71.3073 14.7089 67.4649 20.3041 60.308L19.5163 59.692ZM1.02612 72.4993C16.6767 71.6808 27.7112 65.887 34.3415 60.3848L33.7028 59.6152C27.2258 64.9903 16.3939 70.6942 0.973885 71.5007L1.02612 72.4993ZM189 59.5H34.0222V60.5H189V59.5ZM190.5 58C190.5 58.8284 189.828 59.5 189 59.5V60.5C190.381 60.5 191.5 59.3807 191.5 58H190.5ZM190.5 3V58H191.5V3H190.5ZM189 1.5C189.828 1.5 190.5 2.17157 190.5 3H191.5C191.5 1.61929 190.381 0.5 189 0.5V1.5ZM7.77875 1.5H189V0.5H7.77875V1.5Z",
    fill: "#FF3D00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalk);
export default __webpack_public_path__ + "static/media/Talk.5a64daf374758569416b23cb013cd325.svg";
export { ForwardRef as ReactComponent };